import { CompanyAuthenticationFormWebComponent } from './component/CompanyAuthenticationFormWebComponent';
import { WEB_COMPONENT_COMPANY_AUTHENTICATION_FORM } from '../../../webcomponents.constants';

export { CompanyAuthenticationFormWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANY_AUTHENTICATION_FORM, CompanyAuthenticationFormWebComponent);
